import { Grid, Skeleton } from '@mui/material'

export type TextSkeletonProps = {
  count?: number
  width?: number
}

const widths = [40, 70, 60, 80, 50]

export const TextSkeleton = ({ count = 1, width }: TextSkeletonProps) => {
  const sizes = Array.from(Array(count)).map(
    (_, i) => width ?? widths[i % widths.length],
  )
  return (
    <Grid container>
      {sizes.map((size, index) => (
        <Grid item xs={12} key={index}>
          <Skeleton
            variant="text"
            width={`${size}%`}
            animation="wave"
            data-testid="text-skeleton-row"
          />
        </Grid>
      ))}
    </Grid>
  )
}
